const TableSearch = ({
  options = [],
  handleSearch = () => {},
  resetSearch = () => {},
  searchType = "",
  search = "",
  setSearch = null,
  setSearchType = null,
  isResetBtnOpen=true
}) => {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
      {/* dropdown */}
      <select
        value={searchType || ""}
        onChange={(e) => {
          setSearchType(e.target.value);
          setSearch("");
        }}
        className="p-2 border border-gray-400 rounded-xl"
      >
        <option value="">Select filter by…</option>
        {options.map((item) => (
          <option key={item?.value} value={item?.value}>
            {item?.name}
          </option>
        ))}
      </select>

      {/* search input + buttons */}
      {searchType && (
        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2 w-full">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={`Search By ${searchType}...`}
            className="flex-1 rounded-xl border border-zinc-200 px-3 py-2 outline-none placeholder:text-zinc-400 focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
          />
          <div className="flex gap-1 mt-2 sm:mt-0">
            <button
              type="button"
              className="text-white bg-blue-500 px-4 py-2 rounded-xl hover:bg-blue-400 cursor-pointer"
              onClick={handleSearch}
            >
              Search
            </button>
           { isResetBtnOpen &&  <button
              type="button"
              className="text-white bg-gray-500 px-4 py-2 rounded-xl hover:bg-gray-400 cursor-pointer"
              onClick={() =>{ resetSearch(1);setSearchType(null);setSearch(null)}}
            >
              Reset
            </button>
           }
          </div>
        </div>
      )}
    </div>
  );
};

export default TableSearch;
